import { connect } from 'react-redux'

import { WGS_RESULTS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './WgsResults'

function mapStateToProps() {
  return {}
}

const LocalizedComponent = withLocalization(Component, WGS_RESULTS)

export default connect(mapStateToProps, null)(LocalizedComponent)
